module.exports = __webpack_public_path__ + "static/blog-desk-e81e73bb5b8ecff1235f49ccc18b9aca.png";